export default {
    LOCALE_HTML: {
        'msg.language': 'zh_TW',
        'msg.title': '標題',
        'msg.type': '問題分類',
        'msg.des': '問題描述',
        'msg.phone': '手機號',
        'msg.regionCode': '區號',
        'msg.email': '郵箱',
        'msg.choose': '選擇要留言的業務',
        'msg.detail': '留言詳情',
        'msg.back': '返回',
        'your.msg': '請您留言',
        'msg.record': '留言記錄',
        'msg.success': '留言成功',
        'to.record': '前往留言記錄',
        completed: '完成',
        submit: '提交',
        'success.desc': '您的留言已成功提交，謝謝',
        'msg.form.input': '請輸入',
        'msg.reply': '回復',
        'comment.suc': '感謝您的評價！',
        'comment.fail': '提交失敗',
        'comment.placeholder': '歡迎給我們的服務提建議',
        'reply.suc': '提交成功！',
        'reply.fail': '請輸入您的回復內容',
        'reply.placeholder': '請輸入您的回復內容',
        'msg.more': '查看更多',
        'msg.collapse': '收起',
        'msg.myservice': '我的服務評價',
        'msg.evaluate': '服務評價',
        'msg.evaluateTitle': '服務評價',
        'msg.score': '評分：',
        'msg.remark': '評語：',
        'msg.status.created': '已創建',
        'msg.status.pending': '待受理',
        'msg.status.processing': '受理中',
        'msg.status.solved': '已完成',
        'msg.service.reply': '客服回復',
        'msg.my.reply': '您的回覆',
        'msg.toast.des': '問題描述為空',
        'msg.toast.type': '問題分類為空',
        'msg.toast.title': '標題為空',
        'msg.toast.none': '不能為空',
        'msg.toast.noAnnex': '請上傳附件',
        'msg.toast.noEmail': '郵箱不能為空',
        'msg.toast.noTel': '手機號不能為空',
        'msg.toast.noRegionCode': '區號不能為空',
        'msg.toast.noZone': '請選擇時區',
        'msg.toast.noDateTime': '請選擇日期時間',
        'msg.toast.email': '請輸入正確的郵箱',
        'msg.toast.tel': '請輸入正確的手機號',
        'msg.toast.regionCode': '請選擇區號',
        'msg.toast.num': '請輸入正確的數字',
        'msg.toast.annex': '請上傳附件',
        'msg.toast.char': '請輸入正確的字符',
        'msg.list.none': '暫無數據',
        'msg.form.choose': '請選擇',
        'msg.form.chooseZone': '選擇時區',
        'msg.form.chooseTime': '選擇時間',
        'msg.form.chooseDate': '選擇日期',
        'msg.form.sure': '確定',
        'msg.form.search': '搜索. ..',
        'msg.form.uploadError': '格式錯誤',
        'msg.form.uploadXss': '上傳失敗，文件內容含有非法腳本',
        'msg.update.time': '更新于',
        'msg.replace.images': '图片',

        MSG016: '已解決',
        MSG017: '未解決',
        MSG019: '提交',
        MSG072: '評價標籤不能為空！',
        MSG073: '評價語不能為空！',
        MSG074: '標籤:',
        MSG075: '是否解決:',
        MSG076: '請選擇問題是否解決',
        MSG015: '該工單是否解決了您的問題？',

        'file.size.limit': '文件大小不能超過50MB',
        'detail.file.limit': '最多15個，大小不超過50M',
        'form.question.des.tip': '請輸入問題描述',
        'form.title.tip': '請輸入標題',
        'form.class.tip': '請選擇問題分類',
        'upload.file': '上傳附件',
        'file.count.limit': '最多只能上傳15個附件',
        'select.search.placeholder': '搜索關鍵字',
        'msg.form.sizeError1': '請上傳小於5M的附件',
        'msg.form.sizeError2': '請上傳小於50M的附件',
        'msg.form.submit': '提交中...',
        'msg.form.upload': '上傳中...',
        'msg.email.tip1': '沒有查詢到您的留言',
        'msg.email.tip2': '如您之前有過留言，可通過郵箱驗證查看',
        'msg.email.tip3': '開始郵箱驗證',
        'msg.email.noData': '當前賬號下暫無數據',
        'email.verify.tip': '輸入留言時使用的郵箱地址',
        'email.input.placeholder': '請輸入郵箱地址',
        'email.submit': '發送郵件',
        'email.rules.error': '請輸入正確的郵箱',
        'email.code.tip': '郵件已發送，請輸入您收到的驗證碼',
        'email.code.placeholder': '請輸入驗證碼',
        'email.code.submit': '立即查看',
        'email.notFind.customer': '未查詢到客戶信息',
        'email.code.wrong': '驗證碼錯誤，請重新輸入',
        'email.code.expired': '驗證碼已過期，請重新驗證郵箱',
        'email.code': '驗證碼',
        'email.send.frequently': '操作過於頻繁請稍後再試',
        'comment.fail.400133': '該工單已評價',
        'not.get.user.info': '無法獲取您的資訊',
        'user.verify.tip': '您需要請通過驗證後才能查看留言清單內容',
        'verify.type.email': '郵箱驗證',
        'verify.text': '驗證',
        'cancel.text': '取消',
        'get.verify.code': '獲取驗證碼',
        'reGet.verify.code': '重新獲取 ',
        'verify.by.email.tip': '驗證碼將通過郵件發送至您輸入的郵箱帳號中',
        'verify.type.phone': '簡訊驗證',
        'phone.placeholder': '請輸入手機號',
        'verify.by.phone.tip': '驗證碼將通過短信發送至您輸入的手機號中',
        'phone.error': '請輸入正確的手機號',
        'phone.errorCode400150': '驗證碼發送頻繁',
        'phone.errorCode400233': '簡訊範本不能為空',
        'phone.errorCode400234': '行銷簡訊餘額不足',
        'phone.errorCode400235': '通知簡訊餘額不足',
        'phone.errorCode400247': '工單挿件簡訊配寘錯誤',
        'phone.errorCode4400248': '獲取簡訊範本失敗',
        'phone.errorCode400249': '該號碼非現有用戶手機號',
        'phone.errorCode400250': '驗證碼已過期，請重新獲取'
    },
    LOCALE_REQUEST: {
        400016: '取得工單資訊已過期，請刷新！'
    },
    LOCALE_SYSTEM: {
        MSG005: ({ name }) => `您好，客服${name}接受了您的請求`,
        MSG012: (color) =>
            ` 您可以<span style="color:${color};text-decoration:underline;" class="js-leave-msg">留言</span>`,
        MSG013: '發給客服'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: '刪除',
                cancel: '取消',
                confirm: '確定',
                inert: '插入',
                width: '寬度',
                height: '高度'
            },
            controls: {
                clear: '清除内容',
                undo: '復原',
                redo: '取消復原',
                fontSize: '字型大小',
                color: '顏色',
                textColor: '文字顏色',
                backgroundColor: '背景顏色',
                tempColors: '臨時顏色',
                bold: '粗體',
                lineHeight: '行高',
                letterSpacing: '字間距',
                textIndent: '段落縮進',
                increaseIndent: '增加縮進',
                decreaseIndent: '减少縮進',
                border: '邊框',
                italic: '斜體',
                underline: '底線',
                strikeThrough: '刪除線',
                fontFamily: '字體',
                textAlign: '文字對齊',
                alignLeft: '置左',
                alignCenter: '置中',
                alignRight: '置右',
                alignJustify: '左右對齊',
                floatLeft: '左浮動',
                floatRight: '右浮動',
                superScript: '上標',
                subScript: '下標',
                removeStyles: '清除樣式',
                headings: '標題',
                header: '標題',
                normal: '常規',
                orderedList: '有序列表',
                unorderedList: '無序列表',
                blockQuote: '引用',
                code: '程式碼',
                link: '連結',
                unlink: '清除連結',
                hr: '水平線',
                media: '媒體',
                mediaLibirary: '媒體庫',
                emoji: '表情符號',
                fullscreen: '全螢幕',
                exitFullscreen: '退出全螢幕'
            },
            linkEditor: {
                textInputPlaceHolder: '輸入連結文字',
                linkInputPlaceHolder: '輸入連結地址',
                inputWithEnterPlaceHolder: '輸入連結地址並換行',
                openInNewWindow: '在新視窗打開',
                removeLink: '移除連結'
            },
            audioPlayer: {
                title: '播放音檔'
            },
            videoPlayer: {
                title: '播放影片',
                embedTitle: '嵌入式媒體'
            },
            media: {
                image: '圖片',
                video: '影片',
                audio: '音檔',
                embed: '嵌入式媒體'
            }
        },
        finder: {
            remove: '删除',
            cancel: '取消',
            confirm: '确认',
            insert: '插入所选项目',
            width: '宽度',
            height: '高度',
            image: '图片',
            video: '视频',
            audio: '音频',
            embed: '嵌入式媒体',
            caption: '媒体库',
            dragTip: '点击或拖动文件至此',
            dropTip: '放开鼠标以上传',
            selectAll: '选择全部',
            deselect: '取消选择',
            removeSelected: '删除选中项目',
            externalInputPlaceHolder: '资源名称|资源地址',
            externalInputTip: '使用“|”分隔资源名称和资源地址',
            addLocalFile: '添加本地资源',
            addExternalSource: '添加网络资源',
            unnamedItem: '未命名项目',
            confirmInsert: '插入选中项目'
        }
    }
}
